module.exports = "/_next/static/images/HeroIndustryStartups-75bdbe9cc5920e91e835a804ede13cd7.webp";